define('wcs.zmetrics', ['require', 'jquery'],function(require, $) {

	var deferred = new $.Deferred(),
		CMdeferred = new $.Deferred(),
		GTMdeferred = new $.Deferred();

	// Setup zm object - this is used with a plugin pattern
	// to attach multiple listeners for GTM and CoreMetrics
	// to a common API
	//
	// TODO: VFDP-11651 Need to remove zm object and zmetrics.js without
	// breaking GTM or CoreMetrics
	window.zm = window.zm || {

		listeners: [], // Array that the listener plugins will attach to

		/* ==========================================================
		 * required parameters:
		 * 	pageId
		 * 	storeId
		 * 
		 * This function is called at the end of the body of every page.
		 * ========================================================== */
		trackPageView: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].pageView) {
					zm.listeners[l].pageView(parameters);
				}
			}
		},

		/* ==========================================================
		 * required parameters:
		 * 	pageId
		 * 	productId
		 * 	productName
		 * 	storeId
		 * 
		 * Call in PDP and/or Quick view
		 * ========================================================== */
		trackProductView: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].productView) {
					zm.listeners[l].productView(parameters);
				}
			}
		},

		/* ==========================================================
		 * required parameters:
		 * 	productId
		 * 	productName
		 * 	quantity
		 * 	unitPrice
		 * 	storeId
		 * ========================================================== */
		trackAddedItem: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].addedItem) {
					zm.listeners[l].addedItem(parameters);
				}
			}
		},

		/* ==========================================================
		 * required parameters:
		 * 	productId
		 * 	productName
		 * 	quantity
		 * 	unitPrice
		 * ========================================================== */
		trackRemovedItem: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].removedItem) {
					zm.listeners[l].removedItem(parameters);
				}
			}
		},

		/* ==========================================================
		 * requires parameters to be an array of an object with the following fields:
		 * 	productId
		 * 	productName
		 * 	quantity
		 * 	unitPrice
		 * 	storeId
		 * 
		 * Call in the shopping cart page.
		 * ========================================================== */
		trackShoppingCart: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].shoppingCart) {
					zm.listeners[l].shoppingCart(parameters);
				}
			}
		},

		/* ==========================================================
		 * required fields in products
		 * 	an array of product with each product having the following fields:
		 * 	productId
		 * 	productName
		 * 	quantity
		 * 	unitPrice
		 * 
		 * required fields in parameters:
		 * 	orderId
		 * 	orderSub
		 * 	orderShipping
		 * 
		 * Call in the checkout completion page
		 * ========================================================== */
		trackCheckoutStep: function(products, parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].checkoutStep) {
					zm.listeners[l].checkoutStep(products, parameters);
				}
			}
		},

		/* ==========================================================
		 * required fields in parameters:
		 * 	step
		 * 	event
		 * 
		 * Call in the checkout completion page
		 * ========================================================== */
		trackCheckoutEvent: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].checkoutEvent) {
					zm.listeners[l].checkoutEvent(parameters);
				}
			}
		},

		/* ==========================================================
		 * required fields in products
		 * 	an array of product with each product having the following fields:
		 * 	productId
		 * 	productName
		 * 	quantity
		 * 	unitPrice
		 * 
		 * required fields in parameters:
		 * 	orderId
		 * 	orderSub
		 * 	orderDiscountAdjustmentProductTotal
		 * 	orderDiscountAdjustment
		 * 	orderAdjustmentShipping
		 * 	orderShipping
		 * 	orderTax
		 * 	orderTotal
		 * 	customerId
		 * 
		 * Call in the checkout completion page
		 * ========================================================== */
		trackOrder: function(products, parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].orderView) {
					zm.listeners[l].orderView(products, parameters);
				}
			}
		},

		/* ==========================================================
		 * required parameters:
		 * 	customerId
		 * 
		 * Call this in my account landing page.
		 * ========================================================== */
		trackLogin: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].registrationView) {
					zm.listeners[l].registrationView(parameters);
				}
			}
		},

		/* ==========================================================
		 * required parameters:
		 * 	event
		 * 
		 * Call this for any event.
		 * ========================================================== */
		trackEvent: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].trackEvent) {
					zm.listeners[l].trackEvent(parameters);
				}
			}
		},

		/* ==========================================================
		 * Call this for any generic tracking of random values
		 * ========================================================== */
		trackGeneric: function(parameters) {
			for(var l in zm.listeners) {
				if(zm.listeners[l].trackGeneric) {
					zm.listeners[l].trackGeneric(parameters);
				}
			}
		}
	};

	var cmEnabled = WCS_CONFIG.get('ANALYTICS::cmEnabled'),
		gtmEnabled = WCS_CONFIG.get('ANALYTICS::gtmEnabled');

	// Load and Attach CoreMetrics listeners
	if(cmEnabled) {
		require(['wcs.cm-listener'],function(cmListener) {
			// initialize coremetrics listener
			var cmParams = {
				clientId: WCS_CONFIG.get('ANALYTICS::cmClientId'),
				cmManaged: WCS_CONFIG.get('ANALYTICS::cmManaged'),
				dcDomain: WCS_CONFIG.get('ANALYTICS::dcDomain'),
				cookieDomain: WCS_CONFIG.get('ANALYTICS::cmCookieDomain')
			};
			window.cm.initMetrics(cmParams);
			CMdeferred.resolve();
		});
	} else {
		// Proceed when CM is not enabled
		CMdeferred.resolve();
	}

	// Load and Attach GTM listenrs
	if(gtmEnabled) {
		require(['wcs.gtm-listener'],function(gtmListener) {
			window.gtm.initMetrics();
			GTMdeferred.resolve();
		});
	} else {
		// proceed when GTM is not enabled
		GTMdeferred.resolve();
	}

	$.when(CMdeferred,GTMdeferred)
		.done(function() {
			deferred.resolve(window.zm);
		})
		.fail(function() {
			console.error('Problems loading analytics modules');
			deferred.reject(null);
		});

	return deferred.promise();
});
